import React from 'react';
import BzmIcon from '../../icons/BzmIcon';
import style from './DrozponeVisual.module.css';
import clsx from 'clsx';

interface DropzoneDivProps {
  title: string;
  subtitle: any;
}

const DropzoneVisual = (props: DropzoneDivProps) => {
  return (
    <div className={clsx('d-flex justify-content-center text-left', style.content)}>
      <BzmIcon variant={'icon-bzm-upload-cloud'} className={'icon-jb mr-4'} />
      <div>
        <h1 className="mb-2">{props.title}</h1>
        {props.subtitle}
      </div>
    </div>
  );
};

export default DropzoneVisual;
